import { Component, OnInit, ViewChild } from '@angular/core';
import { FILE_UPLOADER } from 'src/app/componentes/file-uploader/file-uploader.component';
import { SugestaoService } from 'src/app/service/sugestao/sugestao.service';
import { AuthService } from 'src/app/service/autenticacao/auth.service';
import { Router } from '@angular/router';
import { OK_MANIFESTO_ENVIADO, ERRO_DADOS_NAO_GRAVADOS, ERRO_DADOS_OBRIGATORIOS, ERRO_ASSUNTO_OBRIGATORIO } from 'src/app/tools/Mensagens';
import { PAGINA_SUCESSO_FORM } from 'src/app/tools/URL';
import { SugestaoVO } from 'src/app/entity/SugestaoVO';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'sugestao',
  templateUrl: './sugestao.component.html',
  styleUrls: ['./sugestao.component.css']
})
export class SugestaoComponent implements OnInit {
  @ViewChild(FILE_UPLOADER, { static: false }) fileUploader;

  constructor(public service: SugestaoService,
    public authService: AuthService,
    private router: Router) { }

  ngOnInit() {
    this.service.carregarDados().subscribe(retorno => {
      this.service.sugestao.controls.nome.setValue(this.authService.usuarioDTO.nome);
      this.service.sugestao.controls.email.setValue(this.authService.usuarioDTO.email);
      if (retorno) {
        this.service.sugestao.controls.listaClassificacaoCompleta.setValue(retorno.listaClassificacaoCompleta);
        this.service.sugestao.controls.assuntos.setValue(retorno.assuntos);
        this.checarAssuntoUnico();
      }
    })
  }

  checarAssuntoUnico() {
    if (this.service.sugestao.controls.assuntos.value != null && this.service.sugestao.controls.assuntos.value.length == 1) {
      this.changeAssunto(this.service.sugestao.controls.assuntos.value[0]);
    }
  }

  onSubmit() {
    if (this.service.sugestao.value.assunto) {
      this.preencherDados();
      if (this.service.sugestao.valid) {
        this.service.enviar(this.service.sugestao.value).subscribe(retorno => {
          if (retorno) {
            alert(OK_MANIFESTO_ENVIADO);
            this.router.navigate([PAGINA_SUCESSO_FORM]);
          } else {
            alert(ERRO_DADOS_NAO_GRAVADOS);
          }
        });
      } else {
        const campos = this.tratarMensagemDeErro();
        alert(ERRO_DADOS_OBRIGATORIOS + campos);
      }
    } else {
      alert(ERRO_ASSUNTO_OBRIGATORIO);
    }
  }

  preencherDados() {
    this.service.sugestao.controls.nome.setValue(this.authService.usuarioDTO.nome)
    this.service.sugestao.controls.email.setValue(this.authService.usuarioDTO.email)
    this.service.sugestao.value.files = [];
    this.fileUploader.mapFilesBase64.forEach((value, key) => {
      this.service.sugestao.value.files.push({
        nomeArquivo: key,
        conteudo: value
      });
    });
  }

  tratarMensagemDeErro() {
    let campos: String[] = [];
    let contrutorSugestaoVO: any = SugestaoVO.prototype.constructor;
    Object.values(this.service.sugestao.controls).forEach((value: AbstractControl) => {
      if (!value.valid) {
        const formGroup = value.parent.controls;
        campos.push("\n" + contrutorSugestaoVO.descricaoAtributos[Object.keys(formGroup).find(name => value === formGroup[name])]);
      }
    });
    return campos;
  }

  changeAssunto(item) {
    this.service.sugestao.controls.assunto.setValue(item);

    this.service.sugestao.value.listaClassificacaoCompleta
      .map(item => item.selecionado = false);

    this.service.sugestao.value.assuntos
      .filter(assunto => assunto.id === item.id)
      .forEach((assunto: any) => assunto.selected = true);

    this.service.sugestao.value.assuntos
      .filter(assunto => assunto.id !== item.id)
      .forEach((assunto: any) => assunto.selected = false);

    this.resetFormControl();
  }

  resetFormControl() {
    this.service.sugestao.controls.descricaoSugestao.setValue('');
  }

  zeraListaClassificacao() {
    this.service.sugestao.value.listaClassificacao = [];
  }

  desmarcarCheckOutrosAssuntos() {
    this.service.sugestao.value.listaClassificacaoCompleta
      .map(item => item.selecionado = false);
    this.service.sugestao.controls.descricaoSugestao.reset();
  }

  isChecked(item) {
    return this.service.sugestao.controls.assunto.value == item;
  }

}
